import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import { Outlet } from 'react-router';
import { FlexBox } from '../layout';

interface BaseTemplateProps {
  navBarProps?: {
    hideNavbar?: boolean;
    defaultOpen?: boolean;
  };
  navBar?:
    | React.ReactNode
    | ((props: {
        isOpen: boolean;
        setIsOpen: (open: boolean) => void;
      }) => React.ReactNode);
  environmentBanner?: React.ReactNode;
  menuIcon?: React.ReactNode;
  collapseIcon?: React.ReactNode;
}

const BaseTemplate: React.FC<BaseTemplateProps> = ({
  navBarProps,
  navBar,
  environmentBanner,
  menuIcon,
  collapseIcon,
}) => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(
    navBarProps?.defaultOpen || false
  );

  return (
    <FlexBox py={1} minHeight={'100vh'}>
      {typeof navBar === 'function'
        ? navBar({ isOpen: isNavbarOpen, setIsOpen: setIsNavbarOpen })
        : navBar}
      <FlexBox flexDirection={'column'} minWidth={0} width={'100%'}>
        {!navBarProps?.hideNavbar && (
          <FlexBox
            position={'sticky'}
            top={0}
            zIndex={999}
            flexDirection={'column'}
            width={'100%'}
          >
            <FlexBox
              px={[2, 3]}
              pt={1}
              pb={0}
              bgcolor={(theme) => theme.palette.gold?.[50]}
              alignItems={'center'}
              justifyContent={'space-between'}
              width={'100%'}
              position={'relative'}
            >
              <IconButton
                onClick={() => setIsNavbarOpen((prev) => !prev)}
                color="secondary"
              >
                {isNavbarOpen ? collapseIcon : menuIcon}
              </IconButton>
              {environmentBanner}
              <FlexBox
                px={[2, 3]}
                position={'absolute'}
                height={'0.5rem'}
                bottom={'-0.5rem'}
                left={0}
                right={0}
                background={(theme) =>
                  `linear-gradient(to bottom, ${theme.palette.gold?.[50]} 0%, rgba(255,255,255,0) 100%)`
                }
              />
            </FlexBox>
          </FlexBox>
        )}
        <FlexBox px={[2, 3]} height={'100%'} flexDirection={'column'}>
          <FlexBox
            p={[2, 4]}
            flexDirection="column"
            flexGrow={1}
            bgcolor={'common.white'}
            boxShadow={(theme) => theme.shadows[4]}
          >
            <Outlet />
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
};

export default BaseTemplate;
